/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Page from 'material/structure/page/page';
import Content from 'material/structure/content/content';
import Title from 'material/copy/title/title';
import ControlBar from 'material/embeds/controlbar/controlbar';
// ctas
import ContentAnalyticsCard from 'material/embeds/contentanalyticscard/contentanalyticscard_container';
import BackToEmbedsCTA from 'material/ctas/backtoembeds/backtoembeds';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/analytics/embedcontent/embedcontent_styles';



/* ========== ~~~~~~~~~~ PAGE : EMBED CONTENT : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class EmbedContent extends Component {
    constructor(props) {
        super(props);
        this.items = Object.assign([], this.props.contents);
        this.typedText = '';
        this.content = [];
        this.status = [];
        this.state = {
            filteredItems: Object.assign([], this.props.contents),
            navigatingToEditor: false
        };
    }
    // componentDidUpdate(prevProps) {
    //     if (prevProps.contents !== this.props.contents) {
    //         this.items = Object.assign([], this.props.contents);
    //         this.setState({filteredItems: this.items});
    //     }
    // }

    getDetail = (content) => ((content.contentType === 'story') ? content.story : content.questionBased);

    applyFilters = () => {
        // store existing filter types
        const types = { content: this.content.length > 0, status: this.status.length > 0, search: this.typedText.length > 0 };
        // filter items based on type that exists and value
        let filteredItems = this.items.filter(content => {
            if (types.content && types.status) {
                return this.content.some(filter => filter === content.contentType) && this.status.some(filter => filter === `${content.contentLive}`);
            } else if (types.content) {
                return this.content.some(filter => filter === content.contentType);
            } else if (types.status) {
                return this.status.some(filter => filter === `${content.contentLive}`);
            } else {
                return this.items;
            }
        });
        // now search what was filtered
        if (types.search) filteredItems = filteredItems.filter(content => {
            let optionHasSearchedText = false;
            const contentDetail = this.getDetail(content);
            if(contentDetail.options) Object.entries(content.questionBased.options).forEach(option => (option[1].text !== null ? option[1].text.toLowerCase().includes(this.typedText.toLowerCase()) : false) ? optionHasSearchedText = true : null)
            return contentDetail.title.toLowerCase().includes(this.typedText.toLowerCase()) || optionHasSearchedText;
        });
        // render filter items
        this.setState({ filteredItems: filteredItems });
    };
    handleSearch = (typedText) => {
        this.typedText = typedText;
        this.applyFilters();
    };
    engageEditor = () => { 
        if(!this.state.navigatingToEditor) this.setState({ navigatingToEditor: true });
    }
    _renderContents() {
        return this.state.filteredItems.map(content => <ContentAnalyticsCard key={this.getDetail(content).contentUUID}
                                                                            content={content}
                                                                            engageEditor={this.engageEditor} 
                                                                            navigatingToEditor={this.state.navigatingToEditor} />);
    }
    moveToEmbedManagement = () => this.props.moveToPage('customize');
    // --- pagination --- //
    // createRows = (rowData) => {
    //     return rowData.map(content => <ContentAnalyticsCard content={content} />);
    // }
    // initialDataSet = () => {
    //     return this.hasPagination() ? this.items.slice(0, this.rowsPerPage) : this.items;
    // }
    // hasPagination = () => {
    //     return this.rowsPerPage < 1 || this.rowsPerPage === null || this.rowsPerPage === undefined ? false : true;
    // }
    // handlePagination = (e) => {
    //     this.setState({ 
    //         currentIndex: this.getNewIndex(e),
    //         rowMarkup: this.createRows(this.getSlicedRowData(e)) // reset current row markup based on selected pagination control (show next/prev x number of records)
    //     });
    // }
    // getNewIndex = (e) => {
    //     return e === 'next' ? (this.state.currentIndex + this.rowsPerPage) : (this.state.currentIndex - this.rowsPerPage);
    // }
    // getSlicedRowData = (e) => {
    //     const newIndex = this.getNewIndex(e);
    //     const startIndex = newIndex - this.rowsPerPage;
    //     return this.items.slice(startIndex, newIndex);
    // }
    handleSelectType = (types) => {
        this.content = types;
        this.applyFilters();
    };
    handleSelectStatus = (status) => {
        this.status = status;
        this.applyFilters();
    };
    render() {
        return(
            <Page name={`embedcontent`} klass={`${this.props.classes.embedcontent}`}>
                <Content>
                    <Title variant={'withctas'}>
                        {/*<h2>{this.props.embedName}</h2>*/}
                        <BackToEmbedsCTA />
                        {/*<CTAs name={`ctas`}>
                            <Button type={'action'} action={this.moveToEmbedManagement} variant={`primary`} name={`editembed`} text={`Edit Embed`} />
                        </CTAs>*/}
                    </Title>
                    <ControlBar 
                        searchDefaultValue={this.typedText}
                        searchPlaceholder={`Search pages`}
                        searchOnChange={this.handleSearch}
                        handleSelectType={this.handleSelectType}
                        handleSelectStatus={this.handleSelectStatus}
                    />
                    <Title size={`small`} name={`numberof`}>
                        <h3>
                            <span className={`total`}>Total Pages ({this.items.length})</span>
                            {this.items.length === this.state.filteredItems.length ? null : 
                                <span className={`filtered`}>Sorted Pages ({this.state.filteredItems.length})</span>
                            }
                        </h3>
                    </Title>
                    <div className={`cards`}>
                        {this._renderContents()}
                    </div>
                    {/*
                    <div className={`pager`}>
                        <Pagination 
                            handlePrevious={this.handlePagination} 
                            handleNext={this.handlePagination} 
                            itemsPerPage={this.rowsPerPage}
                            totalItems={this.totalRows}
                            currentIndex={this.state.currentIndex}
                        />
                    </div>
                    */}
                </Content>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(EmbedContent);
